import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Platform from '../views/Platform.vue'

import { getToken } from '@/utils/auth'
import { PlatformChildrenRouterList } from './platformChildrenRouterList'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/platform'
  },
  {
    path: '/platform',
    name: 'Platform',
    component: Platform,
    children: [
      ...PlatformChildrenRouterList.reduce((acc, item) => {
        if (item.children) {
          return [...acc, ...item.children]
        }
        return [...acc, item]
      }, [])
    ]
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  next()
  if(to.name === 'Login') {
    next()
  } else {
    let token = getToken()
    if(token) {
      next()
    } else {
      console.log('跳轉失敗')
      next({ path: '/Login' })
    }
  }
})


export default router
